import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import UserService from '../services/user.service';

const Home = () => {
  const [content, setContent] = useState('');
  const { user: currentUser } = useSelector((state) => state.auth);

  useEffect(() => {
    // ถ้าเป็น ROLE_MODERATOR ให้แสดง PublicContent ทันที
    if (currentUser?.roles?.includes('ROLE_MODERATOR')) {
      UserService.getPublicContent().then(
        (response) => {
          setContent(response.data);
        },
        (error) => {
          const _content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();

          setContent(_content);
        }
      );
      return;
    }

    // สำหรับ user ทั่วไป ให้เช็คข้อมูลจาก getEmploymentByEmpNo ก่อน
    UserService.getEmploymentByEmpNo(currentUser.username).then(
      (response) => {
        console.log('---getEmploymentByEmpNo response---', response.data);
        if(response.data?.emp){
          UserService.getPublicContent().then(
            (response) => {
              setContent(response.data);
            },
            (error) => {
              const _content =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
    
              setContent(_content);
            }
          );
        }else{
          setContent('ไม่พบข้อมูล กรุณาดูวิธีใช้งานหรือติดต่อเจ้าหน้าที่');
        }
      },
      (error) => {
        console.log('---getEmploymentByEmpNo error---', error);
        setContent('');
      }
    );
  }, [currentUser]);

  return (
    <div className="container">
      <header className="jumbotron">
        {content ? (
          <h3>{content}</h3>
        ) : (
          <div>
            <h3>ไม่พบข้อมูลของท่าน</h3>
            <p>
              โปรดอ่านคู่มือทำหลักฐานประกอบการจ้างสำหรับผู้ปฏิบัติงานใหม่
            </p>
            <a 
              href="https://drive.google.com/file/d/1_yc-CYqknlp0P7mKOZqoX4QQ_9QqNZlT/view?usp=sharing" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              คลิกที่นี่เพื่อดูคู่มือ
            </a>
          </div>
        )}
      </header>
    </div>
  );
};

export default Home;
